define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var initalViewport = $(window).width() || 0;
        var $flexibleContents = $(".flexibleContent");
        var flexibleContentColSelector = ".flexibleContent_col";
        $.each($flexibleContents, function (index, parentObj) {
            var winWidth = $(window).width() || 0;
            var children = $(parentObj).find(flexibleContentColSelector);
            $.each(children, function (index, childObj) {
                if (winWidth < Configuration_1.configuration.breakpointMedium) {
                    if (!$(parentObj).hasClass("flexibleContent_col1-showMobile") && $(childObj).hasClass("col-1")) {
                        childObj.remove();
                    }
                    if (!$(parentObj).hasClass("flexibleContent_col2-showMobile") && $(childObj).hasClass("col-2")) {
                        childObj.remove();
                    }
                }
                else if (winWidth < Configuration_1.configuration.breakpointLarge) {
                    if (!$(parentObj).hasClass("flexibleContent_col1-showTablet") && $(childObj).hasClass("col-1")) {
                        childObj.remove();
                    }
                    if (!$(parentObj).hasClass("flexibleContent_col2-showTablet") && $(childObj).hasClass("col-2")) {
                        childObj.remove();
                    }
                }
                else {
                    if (!$(parentObj).hasClass("flexibleContent_col1-showDesktop") && $(childObj).hasClass("col-1")) {
                        childObj.remove();
                    }
                    if (!$(parentObj).hasClass("flexibleContent_col2-showDesktop") && $(childObj).hasClass("col-2")) {
                        childObj.remove();
                    }
                }
            });
        });
        $(window).on("resize", function () {
            var winWidth = $(window).width() || 0;
            if (winWidth < Configuration_1.configuration.breakpointMedium) {
                //if (initalViewport >= configuration.breakpointMedium) location.reload();
            }
            else if (winWidth < Configuration_1.configuration.breakpointLarge) {
                //if (initalViewport < configuration.breakpointMedium || initalViewport >= configuration.breakpointLarge) location.reload();
            }
            else {
                //if (initalViewport < configuration.breakpointLarge) location.reload();
            }
        });
    });
});
